
























































































































































































































































































































































































import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

import { InventoryGroup } from '@/api-svc-types';
import { BaseVue } from '@/BaseVue';
import { StrategyPriority } from '@/components/org/types';
import UiButton from '@/components/ui/UiButton.vue';
import UiCheckbox from '@/components/ui/UiCheckbox.vue';
import UiDatePicker2 from '@/components/ui/UiDatePicker2.vue';
import UiDropdown from '@/components/ui/UiDropdown.vue';
import UiLoading from '@/components/ui/UiLoading.vue';
import UiSelect from '@/components/ui/UiSelect.vue';
import UiSelect2 from '@/components/ui/UiSelect2.vue';
import UiTextEdit from '@/components/ui/UiTextEdit.vue';
import { store } from '@/store';
import { InventoryActionTypes } from '@/store/modules/inventories/types';
import { MUT_GET_SUBS } from '@/store/modules/subsidiaries/types';

import { baConfig } from '../../../config';
import {
  ApiSvcAssetValuationStrategies,
  ApiSvcCreateInventoryViewRequest,
  ApiSvcGainLossSetupDTOTaxStrategyEnum,
  ApiSvcImpairmentMethodology,
  ApiSvcInventoryEffectType,
  ApiSvcInventoryMappingRuleRequest,
  ApiSvcInventoryMappingRuleType,
  ApiSvcPricingMethod,
  ApiSvcPricingPeriod,
  ApiSvcSpecificIdentificationCoinSpendingStrategy,
  ApiSvcSpecificIdentificationSelectionPreference,
  ApiSvcSpecificIdentificationSelectionStrategy,
  InventoryApi,
  LabelsApi,
} from '../../../generated/api-svc';
import UiFormLabel from '../ui/UiFormLabel.vue';
import {
  allStrategies,
  AssetValuationStrategiesType,
  AssetValuationStrategyRequest,
  impairmentMethodologies,
  InventoryViewHelper,
  taxMethodsLabels,
  toAssetValuationStrategyRequests,
  valuationMethodologyOptions,
} from './helpers/inventoryViewHelper';
import { INVENTORY_EFFECT_OPTIONS, labelEffectsError, labelOptionsForEffect } from './helpers/labelEffects';
import { applyLabelRulesToConfig, LabelInclusionRule, LabelTrackingRule } from './helpers/labelRules';
import {
  applyStrategyOverridesToRequest,
  isQueueBasedStrategy,
  strategyOverrideOptions,
  TaxStrategyOverrideRow,
  validateStrategyOverrideRows,
} from './helpers/strategyOverrides';
import InventoryViewLabelRules from './InventoryViewLabelRules.vue';
import InventoryViewTrackingDimension from './InventoryViewTrackingDimension.vue';
import TaxStrategyPicker from './TaxStrategyPicker.vue';

@Component({
  components: {
    UiSelect,
    UiSelect2,
    InventoryViewLabelRules,
    InventoryViewTrackingDimension,
    UiDropdown,
    UiCheckbox,
    UiButton,
    UiTextEdit,
    UiLoading,
    UiFormLabel,
    TaxStrategyPicker,
    UiDatePicker2,
  },
})
export default class CreateWalletNew extends BaseVue {
  public isCreatingInventoryView = false;
  public subsidiaryIds: string[] = [];

  public newInventoryName = '';
  public ignoreNFTs = false;
  public ignoreOrgWrappingTreatments = false;
  public costBasisCarryForwardAcquiredSide = false;
  public processAcquisitionsBeforeDisposals = true;
  public useFiatTotalInTradeAcquisitions = false;
  public synthesizeTradeExchangeRates = false;
  public includeFiatActions = false;

  public useOriginalAcquisitionDateForWliTransfers = true;
  public excludeIntercompanyGainLoss = false;
  public isReallocatedView = false;
  public multipleInventories = false;
  public capitalizeFees = true;
  public date = new Date().toISOString().substring(0, 10);
  public isValidInput = false;
  public isValidating = false;
  public showDoneModal = false;
  public taxStrategy: ApiSvcGainLossSetupDTOTaxStrategyEnum = ApiSvcGainLossSetupDTOTaxStrategyEnum.Fifo;
  public impairmentMethodology = ApiSvcImpairmentMethodology.DailyLow;
  public inventoryMapping: ApiSvcInventoryMappingRuleType = ApiSvcInventoryMappingRuleType.PerWallet;
  public specIdStrategy: StrategyPriority[] = [];
  public defaultSelectedInventoryGroup: InventoryGroup = {
    orgId: '',
    walletIdsToInventoryIds: [],
    name: '',
    description: '',
  };

  public expandAdvanced = false;
  public engineVersion = 2.9;

  public matchDataSourceId = '';
  public defaultFairMarketValueMethodology: ApiSvcPricingMethod | null = null;

  // we should only allow selecting the newest engine versions
  public engineVersions = [
    { label: 'v2.8', id: 2.8 },
    { label: 'v2.9', id: 2.9 },
    { label: 'v2.91', id: 2.91 },
    { label: 'v2.92', id: 2.92 },
    { label: 'v3.1', id: 3.1 },
    { label: 'v3.2', id: 3.2 },
    { label: 'v3.3', id: 3.3 },
  ];

  assetValuationStrategies: AssetValuationStrategiesType[] = [];
  public defaultStrategy = ApiSvcAssetValuationStrategies.GaapFairValue;

  public labelDefinitions: {
    labelId: string;
    name: string;
    enabled?: boolean;
    isDeleted?: boolean;
    allowSlugs?: boolean;
    slugType?: string;
  }[] = [];

  public activeLabelEffects: { labelId: string; effect: string }[] = [];
  public strategyOverrides: TaxStrategyOverrideRow[] = [];
  public inventoryEffectTypes = [...INVENTORY_EFFECT_OPTIONS];

  // Transaction Inclusion rule — emitted by the InventoryViewLabelRules component.
  public labelInclusionRule: LabelInclusionRule | undefined = undefined;

  // Inventory tracking dimension — emitted by the InventoryViewTrackingDimension component.
  public labelTrackingRule: LabelTrackingRule | undefined = undefined;

  public avaLabsBviOrgId = 'acdxsokj3hC6MEbcN9Pa';

  public get strategies() {
    if (this.engineVersion === 1) {
      return [allStrategies[0], allStrategies[2]];
    } else if (this.checkFeatureFlag('mark-to-market-no-fmv-rollback')) {
      // Show all strategies when the feature flag is enabled
      return allStrategies.slice(0, 6);
    } else if (this.checkFeatureFlag('impairment')) {
      // Exclude the Mark To Market - No FMV Rollback strategy when 'impairment' is enabled
      if (this.engineVersion < 2) {
        return allStrategies.slice(0, 1).concat(allStrategies.slice(2, 5)); // Excludes GAAP FMV
      }
      return allStrategies.slice(0, 1).concat(allStrategies.slice(2, 6));
    } else {
      // Default case
      return [allStrategies[0], allStrategies[2], allStrategies[3], allStrategies[4]];
    }
  }

  public impairSelect = this.strategies[0];
  public selectedInventoryGroup = this.defaultSelectedInventoryGroup;

  public get impair() {
    return this.impairSelect !== allStrategies[0];
  }

  public get ifrsImpair() {
    return (
      (this.impairSelect === allStrategies[1] ||
        this.impairSelect === allStrategies[2] ||
        this.impairSelect === allStrategies[3] ||
        this.impairSelect === allStrategies[4] ||
        this.impairSelect === allStrategies[5]) &&
      this.engineVersion >= 2
    );
  }

  public get defaultValuationStrategy() {
    let strategy: ApiSvcAssetValuationStrategies | null = null;
    switch (this.impairSelect) {
      case allStrategies[0]:
        strategy = null;
        break;
      case allStrategies[1]:
        strategy = ApiSvcAssetValuationStrategies.MarkToMarket;
        break;
      case allStrategies[2]:
        strategy = ApiSvcAssetValuationStrategies.Impairment;
        break;
      case allStrategies[3]:
        strategy = ApiSvcAssetValuationStrategies.ImpairmentReversalNonRevalued;
        break;
      case allStrategies[4]:
        strategy = ApiSvcAssetValuationStrategies.ImpairmentReversalRevalued;
        break;
      case allStrategies[5]:
        strategy = ApiSvcAssetValuationStrategies.GaapFairValue;
        break;
    }
    return strategy;
  }

  get taxMethods() {
    const selectedSpecId = this.checkFeatureFlag('selected-spec-id');
    const trueHifo = this.checkFeatureFlag('true-hifo');
    return taxMethodsLabels(selectedSpecId, trueHifo);
  }

  public impairmentMethodologies = impairmentMethodologies;
  public valuationMethodologyOptions = valuationMethodologyOptions;

  get fairMarketValueResolutions() {
    return [
      { label: 'Use org default', value: null },
      { label: '15 Minutes', value: ApiSvcPricingPeriod._15m },
      { label: '1 Hour', value: ApiSvcPricingPeriod._1h },
      { label: '1 Day', value: ApiSvcPricingPeriod._1d },
    ];
  }

  get fairMarketValueMethodologies() {
    return [
      { label: 'Use org default', value: null },
      { label: 'Close', value: ApiSvcPricingMethod.Close },
      { label: 'VWAP', value: ApiSvcPricingMethod.Vwap },
      { label: 'Low', value: ApiSvcPricingMethod.Low },
      { label: 'Open', value: ApiSvcPricingMethod.Open },
      { label: 'High', value: ApiSvcPricingMethod.High },
    ];
  }

  public inventoryMappings: {
    [key: string]: ApiSvcInventoryMappingRuleType;
  } = {
    'Per Wallet': ApiSvcInventoryMappingRuleType.PerWallet,
  };

  public includeIntraGroupInternalTransfers = false;

  get inventoryRunIds() {
    return ['7ffe9d9d61f47a68513b79d2bfe5f7'];
  }

  public get validateInventoryName() {
    return this.newInventoryName.length >= 3;
  }

  public get valuationStrategies() {
    if (this.checkFeatureFlag('mark-to-market-no-fmv-rollback')) {
      return InventoryViewHelper.valuationStrategiesByFeatureFlag('mark-to-market-no-fmv-rollback');
    } else if (this.checkFeatureFlag('impairment')) {
      return InventoryViewHelper.valuationStrategiesByFeatureFlag('impairment');
    } else {
      return InventoryViewHelper.valuationStrategiesByFeatureFlag('default');
    }
  }

  public handleSelectInventoryGroup(value: InventoryGroup) {
    this.selectedInventoryGroup = value;
    this.clearStrategyOverridesIfStale();
  }

  @Watch('inventoryMapping')
  @Watch('multipleInventories')
  public onStrategyOverrideTargetsChange() {
    this.clearStrategyOverridesIfStale();
  }

  // Rows point at wallets or inventories; if the mapping mode or group
  // changes, previously selected ids may no longer be valid targets.
  private clearStrategyOverridesIfStale() {
    if (this.strategyOverrides.length === 0) return;
    const validIds = new Set(this.strategyOverrideTargets.map((t) => t.id));
    this.strategyOverrides = this.strategyOverrides.filter((row) => !row.walletId || validIds.has(row.walletId));
  }

  public changeVersion(value: number) {
    if (value === 1) {
      this.multipleInventories = false;
      if (!this.strategies.includes(this.impairSelect)) {
        this.impairSelect = this.strategies[0];
      }
    }
    if (value < 2 && this.impairSelect === allStrategies[5]) {
      this.impairSelect = this.strategies[0];
    }
  }

  // Per-wallet strategy overrides only make sense for multi-inventory,
  // queue-based (FIFO/LIFO/HIFO) views on engine >= 2 — one queue per
  // wallet/inventory, each of which can pop in a different order.
  get showStrategyOverrides() {
    return (
      this.checkFeatureFlag('per-wallet-tax-strategies') &&
      this.multipleInventories &&
      this.engineVersion >= 2 &&
      isQueueBasedStrategy(this.taxStrategy)
    );
  }

  get strategyOverridesUseInventoryTargets() {
    return this.inventoryMapping === ApiSvcInventoryMappingRuleType.GroupMapping;
  }

  get strategyOverrideTargetLabel() {
    return this.strategyOverridesUseInventoryTargets ? 'Inventory' : 'Wallet';
  }

  get strategyOverrideTargets(): { id: string; name: string }[] {
    if (this.strategyOverridesUseInventoryTargets) {
      const inventories: { id?: string; name?: string; inventoryGroupId?: string }[] =
        store.getters['inventories/INVENTORIES'] ?? [];
      return inventories.filter(
        (inv): inv is { id: string; name: string } =>
          !!inv.id && inv.inventoryGroupId === this.selectedInventoryGroup.id
      );
    }
    const wallets: { id?: string; name?: string }[] = store.getters['wallets/WALLETS'] ?? [];
    return wallets.filter((w): w is { id: string; name: string } => !!w.id);
  }

  get strategyOverrideOptions() {
    return strategyOverrideOptions(this.checkFeatureFlag('true-hifo'));
  }

  get orgTimezone() {
    return this.$store.state.currentOrg.timezone;
  }

  get isValid() {
    if (this.multipleInventories && this.inventoryMapping === ApiSvcInventoryMappingRuleType.GroupMapping) {
      if (this.selectedInventoryGroup.id === undefined) return false;
    }
    if (this.impair && !this.defaultValuationStrategy) return false;
    if (this.impair && this.assetValuationStrategies.some((x) => !x.coin || !x.strategy)) return false;
    if (this.isReallocatedView && !this.multipleInventories) return false;
    if (this.showStrategyOverrides && !validateStrategyOverrideRows(this.strategyOverrides)) return false;
    if (this.labelEffectsProblem) return false;
    return this.isValidInput;
  }

  public getIsValid() {
    if (this.multipleInventories && this.inventoryMapping === ApiSvcInventoryMappingRuleType.GroupMapping) {
      if (this.selectedInventoryGroup.id === undefined) return false;
    }
    return this.isValidInput;
  }

  public async validateTickers() {
    // Check if the tickers are valid
    const resp = await new InventoryViewHelper().validateTickers(this.assetValuationStrategies);
    if (resp && !resp.status) {
      this.showErrorSnackbar(resp.msg);
      return false;
    }

    return true;
  }

  public async createInventoryView() {
    this.isCreatingInventoryView = true;

    try {
      const orgId = this.$store.state.currentOrg.id;
      const svc = new InventoryApi(undefined, baConfig.getFriendlyApiUrl());
      const taxStrategy = this.taxStrategy;
      const specIdStrategy = this.mapSpendingStrategy();

      let inventoryMappingRule: ApiSvcInventoryMappingRuleRequest | undefined;
      if (this.multipleInventories) {
        inventoryMappingRule = {
          type: this.inventoryMapping,
        };
        if (this.inventoryMapping === this.inventoryMappings['Inventory Groups'] && this.selectedInventoryGroup.id)
          inventoryMappingRule.inventoryGroupId = this.selectedInventoryGroup.id;
      }
      let defaultValuationStrategy: ApiSvcAssetValuationStrategies | undefined;
      if (this.defaultValuationStrategy) {
        defaultValuationStrategy = this.defaultValuationStrategy;
      }
      let assetValuationStrategies: AssetValuationStrategyRequest[] | undefined;
      if (this.assetValuationStrategies?.length > 0 && this.engineVersion >= 2) {
        if (!(await this.validateTickers())) {
          return;
        }
        assetValuationStrategies = toAssetValuationStrategyRequests(this.assetValuationStrategies);
      }
      const c: ApiSvcCreateInventoryViewRequest = {
        name: this.newInventoryName,
        impair: this.impair,
        ignoreNFTs: this.ignoreNFTs,
        ignoreOrgWrappingTreatments: this.ignoreOrgWrappingTreatments,
        strategy: {
          taxStrategy,
          specIdStrategy,
          matchDataSourceId: this.matchDataSourceId,
        },

        config: {
          capitalizeTradingFees: this.capitalizeFees,
          impairmentMethodology: this.impair ? this.impairmentMethodology : undefined,
          inventoryMappingRule,
          defaultValuationStrategy: this.impair ? defaultValuationStrategy : undefined,
          assetValuationStrategies,
          engineVersionOverride: this.engineVersion,
          costBasisCarryForwardAcquiredSide: this.costBasisCarryForwardAcquiredSide,
          processAcquisitionsBeforeDisposals: this.processAcquisitionsBeforeDisposals,
          useOriginalAcquisitionDateForWliTransfers: this.useOriginalAcquisitionDateForWliTransfers,
          excludeIntercompanyGainLoss: this.excludeIntercompanyGainLoss,
          includeIntraGroupInternalTransfers: this.includeIntraGroupInternalTransfers,
          useFiatTotalInTradeAcquisitions: this.useFiatTotalInTradeAcquisitions,
          synthesizeTradeExchangeRates: this.synthesizeTradeExchangeRates,
          defaultFairMarketValueMethodology: this.defaultFairMarketValueMethodology || undefined,
          activeLabelEffects: this.buildActiveLabelEffectsMap(),
          includeFiatActions: this.includeFiatActions,
        },
        isReallocatedView: this.isReallocatedView,
        subsidiaryIds: this.checkFeatureFlag('multi-currency-subsidiaries') ? this.subsidiaryIds : undefined,
      };

      // labelInclusionRule / labelTrackingRule are not in the generated client yet
      // (regenerate after the api-svc swagger lands); applyLabelRulesToConfig attaches
      // them via a single cast until then (and is unit-tested in labelRules.test.ts).
      applyLabelRulesToConfig(c.config, this.labelInclusionRule, this.labelTrackingRule);

      // strategyOverrides is not in the generated client yet either — same
      // single-cast approach, unit-tested in strategyOverrides.test.ts.
      if (this.showStrategyOverrides) {
        applyStrategyOverridesToRequest(c, this.strategyOverrides);
      }

      await svc.createView(orgId, c, {
        withCredentials: true,
      });

      this.$emit('refresh-views');
      this.$emit('back');
    } catch (e) {
      // Surface API validation failures (bad strategy overrides, duplicate
      // wallets, etc.) instead of failing silently.
      const err = e as { response?: { data?: { message?: string } }; message?: string };
      this.showErrorSnackbar(err.response?.data?.message ?? err.message ?? 'Failed to create inventory view');
      throw e;
    } finally {
      this.isCreatingInventoryView = false;
    }
  }

  public mapSpendingStrategy(): ApiSvcSpecificIdentificationSelectionStrategy[] {
    return this.specIdStrategy.map((s) => {
      let spending: ApiSvcSpecificIdentificationCoinSpendingStrategy;
      let preference: ApiSvcSpecificIdentificationSelectionPreference;
      switch (s.spendingStrategy) {
        case 'ShortTermGain':
          spending = ApiSvcSpecificIdentificationCoinSpendingStrategy.NUMBER_1;
          break;
        case 'LongTermGain':
          spending = ApiSvcSpecificIdentificationCoinSpendingStrategy.NUMBER_3;
          break;
        case 'ShortTermLoss':
          spending = ApiSvcSpecificIdentificationCoinSpendingStrategy.NUMBER_2;
          break;
        default:
          spending = ApiSvcSpecificIdentificationCoinSpendingStrategy.NUMBER_4;
          break;
      }
      switch (s.selectionPreference) {
        case 'Minimize':
          preference = ApiSvcSpecificIdentificationSelectionPreference.NUMBER_1;
          break;
        default:
          preference = ApiSvcSpecificIdentificationSelectionPreference.NUMBER_2;
          break;
      }
      return {
        spendingStrategy: spending,
        selectionPreference: preference,
      };
    });
  }

  public onSpendingStrategyChange(value: StrategyPriority[]) {
    this.specIdStrategy = value;
  }

  public validate(valid: boolean) {
    this.isValidInput = true;
  }

  // public onDateChange(field: 'startDate' | 'endDate', date: string | null) {
  //   if (date === null || this._isValidDate(date)) {
  //     this.date = date ?? '';
  //   }
  // }

  // private _isValidDate(dateString: string) {
  //   // Parse the date string into a Date object
  //   const dateObj = new Date(dateString);
  //   // Check if the date object is valid and the string matches the expected format
  //   return !isNaN(dateObj.getTime()) && /^\d{4}-\d{2}-\d{2}$/.test(dateString);
  // }

  // == hooks ==
  async mounted() {
    await store.dispatch('inventories/' + InventoryActionTypes.GET_INVENTORIES, { orgId: store.state.currentOrg.id });
    if (this.checkFeatureFlag('per-wallet-tax-strategies')) {
      await store.dispatch('wallets/getWallets', store.state.currentOrg.id);
    }
    if (this.checkFeatureFlag('multi-currency-subsidiaries')) {
      await store.dispatch('subsidiaries/' + MUT_GET_SUBS, { orgId: store.state.currentOrg.id });
    }
    if (this.checkFeatureFlag('inventory-management')) {
      this.inventoryMappings = {
        'Per Wallet': ApiSvcInventoryMappingRuleType.PerWallet,
        'Inventory Groups': ApiSvcInventoryMappingRuleType.GroupMapping,
      };
    }
    if (this.checkFeatureFlag('sqlite')) {
      this.engineVersions.push({ label: 'v3.0', id: 3.0 });
    }
    if (this.checkFeatureFlag('engine-v3.1')) {
      this.engineVersions.push({ label: 'v3.1', id: 3.1 });
    }
    if (this.checkFeatureFlag('custom-labels')) {
      await this.loadLabelDefinitions();
    }
  }

  private async loadLabelDefinitions() {
    try {
      const orgId = store.state.currentOrg.id;
      const svc = new LabelsApi(undefined, baConfig.getFriendlyApiUrl());
      const resp = await svc.getOrgLabelDefinitions(
        orgId,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        {
          withCredentials: true,
        }
      );
      if (resp.data?.items) {
        this.labelDefinitions = resp.data.items as any;
      }
    } catch (e) {
      console.error('Failed to load label definitions', e);
    }
  }

  private buildActiveLabelEffectsMap(): { [key: string]: ApiSvcInventoryEffectType } | undefined {
    if (this.activeLabelEffects.length === 0) return undefined;
    const map: { [key: string]: ApiSvcInventoryEffectType } = {};
    for (const effect of this.activeLabelEffects) {
      if (effect.labelId && effect.effect) {
        map[effect.labelId] = effect.effect as ApiSvcInventoryEffectType;
      }
    }
    return Object.keys(map).length > 0 ? map : undefined;
  }

  /** Labels eligible for the row's chosen effect (DateTime slug templates for the acquisition date override). */
  public labelOptionsFor(effect: string) {
    return labelOptionsForEffect(this.labelDefinitions, effect);
  }

  /** First reason the label-effect rows cannot be submitted; mirrors api-svc's view validation. */
  get labelEffectsProblem(): string | undefined {
    if (!this.checkFeatureFlag('custom-labels')) return undefined;
    return labelEffectsError(this.activeLabelEffects, this.engineVersion, this.taxStrategy, this.labelDefinitions);
  }

  // == getters ==
  get inventoryGroups() {
    return store.getters['inventories/INVENTORY_GROUPS'];
  }

  get subsidiaries() {
    return store.getters['subsidiaries/SUBSIDIARIES'] || [];
  }

  @Watch('inventoryMapping')
  switchMultipleInventoryStrategy() {
    this.selectedInventoryGroup = this.defaultSelectedInventoryGroup;
  }

  @Watch('multipleInventories')
  switchMultiple() {
    this.inventoryMapping = ApiSvcInventoryMappingRuleType.PerWallet;
  }
}
